<script lang="ts" setup>
import { shallowRef, watchEffect } from 'vue'
interface Props {
  icon: string
  alt?: string
  type?: 'button' | 'submit' | 'reset'
}
const props = withDefaults(defineProps<Props>(), {
  alt: '',
  type: 'button'
})

const svgComponent = shallowRef('')
watchEffect(() => {
  import(`@/assets/svg/${props.icon}.svg`).then((module) => {
    svgComponent.value = module.default
  })
})
</script>

<template>
  <button :type="props.type">
    <img :src="svgComponent" :alt="props.alt" />
  </button>
</template>

<style lang="scss" scoped>
button {
  background: none;
  border: none;
  display: flex;
  padding: 0;

  img[alt='Next'] {
    transform: rotate(180deg);
  }
}
</style>
